/* */
import { useEffect } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import actions from 'redux/actions';
import { permissionToGetRouteList } from '../../consts/permission';

const { getLoadRouteList } = actions;

export default () => {
  const dispatch = useDispatch();
  const authReducer = useSelector((state) => state.authReducer, shallowEqual);
  const userServletReducer = useSelector((state) => state.userServletReducer, shallowEqual);
  const { data } = userServletReducer;
  const { role } = data || {};
  return useEffect(() => {
    if (authReducer.isLogin && authReducer.sessionId && permissionToGetRouteList.includes(role)) {
      dispatch(getLoadRouteList());
    }
  }, [dispatch, authReducer.isLogin, role]);
};
